"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerrainAcquisition = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Tags_1 = require("../../Tags");
const LandClaim_1 = require("../../base/LandClaim");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
class TerrainAcquisition extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.TERRAIN_ACQUISITION,
            metadata: {
                cardNumber: 'Y26',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.cards(3).secondaryTag(Tags_1.Tags.BUILDING).br;
                    b.landClaimTile(4);
                }),
                description: 'Draw 3 building cards. Place 4 of your markers on non-reserved areas. Only you may place tiles there.',
            },
        });
    }
    play(player) {
        player.drawCard(3, { tag: Tags_1.Tags.BUILDING });
        for (let i = 0; i < 4; i++) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                return LandClaim_1.LandClaim.selectSpaceForClaim(player);
            }));
        }
        return undefined;
    }
}
exports.TerrainAcquisition = TerrainAcquisition;
//# sourceMappingURL=TerrainAcquisition.js.map